import React from 'react';
import { motion } from 'framer-motion';

interface TourProgressBarProps {
  duration: number; // Duration in milliseconds
}

export const TourProgressBar: React.FC<TourProgressBarProps> = ({ duration }) => {
  return (
    <div className="fixed top-0 left-0 w-full h-1.5 z-[70]">
      <motion.div
        className="h-full"
        style={{ backgroundColor: '#FF4500' }}
        initial={{ width: '100%' }}
        animate={{ width: '0%' }}
        transition={{ duration: duration / 1000, ease: 'linear' }}
      />
    </div>
  );
};

export default TourProgressBar;
